__turbopack_context__.v({
  "alignmentRight": "featureHighlight-module-scss-module__CkZHYa__alignmentRight",
  "bgImage": "featureHighlight-module-scss-module__CkZHYa__bgImage",
  "bgImageActive": "featureHighlight-module-scss-module__CkZHYa__bgImageActive",
  "bgStack": "featureHighlight-module-scss-module__CkZHYa__bgStack",
  "carousel": "featureHighlight-module-scss-module__CkZHYa__carousel",
  "item": "featureHighlight-module-scss-module__CkZHYa__item",
  "itemBullets": "featureHighlight-module-scss-module__CkZHYa__itemBullets",
  "itemBulletsActive": "featureHighlight-module-scss-module__CkZHYa__itemBulletsActive",
  "itemBulletsInner": "featureHighlight-module-scss-module__CkZHYa__itemBulletsInner",
  "itemHeadline": "featureHighlight-module-scss-module__CkZHYa__itemHeadline",
  "itemHeadlineActive": "featureHighlight-module-scss-module__CkZHYa__itemHeadlineActive",
  "list": "featureHighlight-module-scss-module__CkZHYa__list",
  "listContent": "featureHighlight-module-scss-module__CkZHYa__listContent",
  "listEyebrow": "featureHighlight-module-scss-module__CkZHYa__listEyebrow",
  "mobileEyebrow": "featureHighlight-module-scss-module__CkZHYa__mobileEyebrow",
  "mobileEyebrowWrapper": "featureHighlight-module-scss-module__CkZHYa__mobileEyebrowWrapper",
  "overlay": "featureHighlight-module-scss-module__CkZHYa__overlay",
  "row": "featureHighlight-module-scss-module__CkZHYa__row",
  "section": "featureHighlight-module-scss-module__CkZHYa__section",
  "slide": "featureHighlight-module-scss-module__CkZHYa__slide",
  "slideBgImage": "featureHighlight-module-scss-module__CkZHYa__slideBgImage",
  "slideBullets": "featureHighlight-module-scss-module__CkZHYa__slideBullets",
  "slideContent": "featureHighlight-module-scss-module__CkZHYa__slideContent",
  "slideHeadline": "featureHighlight-module-scss-module__CkZHYa__slideHeadline",
  "slideOverlay": "featureHighlight-module-scss-module__CkZHYa__slideOverlay",
  "swiper": "featureHighlight-module-scss-module__CkZHYa__swiper",
});
